import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy.js';

import styles from './ContemporaryLandingTextHeaderModule.scss';

const ContemporaryLandingTextHeaderModuleComponent = ({ contemporaryLandingHeader }) => {
    if (!contemporaryLandingHeader) {
        return null;
    }

    const { text } = contemporaryLandingHeader;

    return <div className={styles.header}>{text}</div>;
};

export const ContemporaryLandingTextHeaderModule = createFragmentContainer(
    ContemporaryLandingTextHeaderModuleComponent,
    {
        contemporaryLandingHeader: graphql`
            fragment ContemporaryLandingTextHeaderModule_contemporaryLandingHeader on ContemporaryLandingHeader {
                ... on ContemporaryLandingHeader {
                    text
                }
            }
        `,
    }
);

ContemporaryLandingTextHeaderModuleComponent.propTypes = {
    contemporaryLandingHeader: PropTypes.object,
};
ContemporaryLandingTextHeaderModule.propTypes = {
    ContemporaryLandingSplashHeader: PropTypes.object,
};
